export const REENTRY_PLANS_LIST_PATH = '/reentry-plans';

export const CASE_PLAN_SECTION_SKELETON_COUNT = 3;

export const buildReentryPlanDetailsPath = (casePlanId) =>
  `${REENTRY_PLANS_LIST_PATH}/details/${casePlanId}`;

export const REENTRY_PLANNING_TABS = {
  ALL_PLANS: 'All Plans',
};

export const CASE_PLAN_EDIT_PLAN_PERMISSION = 'case_plan_edit_plan';
export const CASE_PLAN_MANAGE_ALL_PLANS_PERMISSION = 'case_plan_manage_all_plans';
export const CASE_PLAN_PREVIEW_RELEASE_PERMISSION = 'case_plan_preview_release_access';

export const CASE_PLAN_ACCESS_PERMISSIONS = [
  CASE_PLAN_EDIT_PLAN_PERMISSION,
  CASE_PLAN_MANAGE_ALL_PLANS_PERMISSION,
  CASE_PLAN_PREVIEW_RELEASE_PERMISSION,
];

export const REENTRY_PLAN_FEATURE = 'reentry_plan';

export const CASE_PLAN_EXPORT_SUCCESS_MESSAGE =
  'Your export request has been qued and you will receive the export on your emails';

/** activeFeatures / side-nav keys for preview reentry plans */
export const REENTRY_PREVIEW_PLAN_TYPE = 'reentry_plan_preview';

/** activeFeatures / side-nav keys for MVP reentry plans */
export const REENTRY_PLAN_TYPE = 'reentry_plan';

/** Feature keys checked on LOCATIONS.activeFeatures for module access and side nav */
export const REENTRY_VISIBILITY_PLAN_TYPES = [REENTRY_PREVIEW_PLAN_TYPE, REENTRY_PLAN_TYPE];

/** Portal /api/admin/case-plans planTypes query param values */
export const PORTAL_REENTRY_PREVIEW_PLAN_TYPE = 'reentry_preview';

export const PORTAL_REENTRY_PLAN_TYPE = 'reentry';

const PORTAL_PLAN_TYPE_BY_VISIBILITY_KEY = {
  [REENTRY_PREVIEW_PLAN_TYPE]: PORTAL_REENTRY_PREVIEW_PLAN_TYPE,
  [REENTRY_PLAN_TYPE]: PORTAL_REENTRY_PLAN_TYPE,
};

export const mapEntitledPlanTypesToPortalApi = (planTypes = []) =>
  planTypes
    .map((planType) => PORTAL_PLAN_TYPE_BY_VISIBILITY_KEY[planType])
    .filter(Boolean);

export const REENTRY_PLANS_DEFAULT_PAGE_SIZE = 25;

export const REENTRY_PLANS_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const VIEW_PLAN_LINK_COLOR = 'var(--tonal-palette-cerulean-main-20, #0078A2)';

/** Pendo tracking id for the Create New Plan action on the All Plans table */
export const REENTRY_CREATE_NEW_PLAN_BUTTON_ID = 'create-new-plan-button';

/** Modal detail keys for Honest Jobs community resources from reentry plan `resources` groups. */
export const HONEST_JOBS_RESOURCE_DETAIL_FIELD_KEYS = [
  'Eligibility',
  'Availability',
  'Description',
  'Languages',
  'Cost',
  'Next Steps',
  'Website',
  'Facebook',
  'Coverage Area',
  'Required',
  'Last Reviewed',
];

/** Modal detail keys for Honest Jobs job listings from reentry plan `jobs` groups. */
export const HONEST_JOBS_JOB_DETAIL_FIELD_KEYS = [
  'Pay Rate',
  'Frequency',
  'Education Level',
  'Description',
];
